/**
 * Same role as CRA `PUBLIC_URL`: path prefix when the app is not served at
 * domain root. Absolute origins (e.g. `https://pr-N.preview.abrafi.ph`) must
 * not become Vite `base` / React Router `basename` — that makes `/` match no
 * routes and the SPA renders a blank `#root`. Use the URL pathname only.
 */
export function normalizeVitePublicUrlBase(url: string | undefined): string {
  if (!url || url === '/') {
    return '/';
  }

  let path = url;
  if (/^https?:\/\//i.test(url)) {
    try {
      path = new URL(url).pathname || '/';
    } catch {
      return '/';
    }
  }

  if (!path || path === '/') {
    return '/';
  }
  return path.endsWith('/') ? path : `${path}/`;
}

/** React Router basename from Vite `import.meta.env.BASE_URL`. */
export function reactRouterBasenameFromBaseUrl(
  baseUrl: string | undefined,
): string | undefined {
  const raw = (baseUrl ?? '/').replace(/\/$/, '');
  if (!raw || raw === '/' || /^https?:\/\//i.test(raw)) {
    return undefined;
  }
  return raw;
}
